import { render, staticRenderFns } from "./Carrier.vue?vue&type=template&id=0642e4e2&scoped=true&"
import script from "./Carrier.vue?vue&type=script&lang=js&"
export * from "./Carrier.vue?vue&type=script&lang=js&"
import style0 from "./Carrier.vue?vue&type=style&index=0&id=0642e4e2&lang=scss&scoped=scoped&"
import style1 from "./Carrier.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0642e4e2",
  null
  
)

export default component.exports